"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HousesFilters = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var styles = _interopRequireWildcard(require("./HousesFilters.css"));
var _icons = require("@cian/ui-kit-design-tokens/icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HousesFilters = _ref => {
  let {
    houses,
    onClick,
    selectedHouseId
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['filters']
  }, houses.map(house => {
    return /*#__PURE__*/React.createElement("button", {
      className: (0, _clsx.default)(house.id === selectedHouseId && styles['selected'], styles['button']),
      onClick: () => {
        onClick(house.id);
      },
      key: house.id
    }, house.hasProblem && /*#__PURE__*/React.createElement("div", {
      className: styles['warning']
    }, /*#__PURE__*/React.createElement(_icons.IconFunctionalWarningSign16, {
      color: "icon-warning-default"
    })), /*#__PURE__*/React.createElement("div", {
      className: styles['text']
    }, house.name));
  }));
};
exports.HousesFilters = HousesFilters;